import { useState, useEffect } from "react";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import toast from "react-hot-toast";
// Authentication layout components
import BasicLayoutLanding from "layouts/authentication/components/BasicLayoutLanding";

// Images
import loginImage from "assets/images/login_image.jpg";

import apiService from "services/api-service";
import { useNavigate } from "react-router-dom";
function ForgotPassword() {
	const [isDemo, setIsDemo] = useState(false);
	const [input, setEmail] = useState({
		email: "",
	});
	const [error, setError] = useState({
		err: false,
		textError: "",
	});
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	useEffect(() => {
		setIsDemo(process.env.REACT_APP_IS_DEMO === "true");
	}, []);

	const changeHandler = (e) => {
		setEmail({
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = async (e) => {
		setLoading(true);
		e.preventDefault();

		const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

		if (
			input.email.trim().length === 0 ||
			!input.email.trim().match(mailFormat)
		) {
			setError({ err: true, textError: "The email must be valid" });
			return;
		}

		const response = await apiService.post(
			"/forgot-password/",
			{},
			{
				email: input.email,
			}
		);

		if (response.status === 200) {
			toast.success("Email di recupero password inviata con successo.", {
				id: "forgot-password-toast",
			});
			navigate("/auth/login");
		} else {
			toast.error("Errore nell'invio dell'email di recupero password.", {
				id: "forgot-password-toast",
			});
		}
		setLoading(false);
	};

	return (
		<BasicLayoutLanding image={loginImage}>
			<Card>
				<MDBox
					variant="gradient"
					bgColor="info"
					borderRadius="lg"
					coloredShadow="info"
					mx={2}
					mt={-3}
					p={2}
					mb={1}
					textAlign="center"
				>
					<MDTypography
						variant="h4"
						fontWeight="medium"
						color="white"
						mt={1}
					>
						Reset Password
					</MDTypography>
				</MDBox>
				<MDBox pt={4} pb={3} px={3}>
					<MDBox
						component="form"
						role="form"
						method="POST"
						onSubmit={handleSubmit}
					>
						<MDBox mb={4}>
							<MDInput
								type="email"
								label="Email"
								fullWidth
								value={input.email}
								name="email"
								onChange={changeHandler}
								error={error.err}
							/>
						</MDBox>
						{error.err && (
							<MDTypography
								variant="caption"
								color="error"
								fontWeight="light"
							>
								{error.textError}
							</MDTypography>
						)}
						<MDBox mt={6} mb={1}>
							<MDButton
								variant="gradient"
								color="info"
								fullWidth
								type="submit"
								disabled={loading}
							>
								Reset
							</MDButton>
						</MDBox>
					</MDBox>
				</MDBox>
			</Card>
		</BasicLayoutLanding>
	);
}

export default ForgotPassword;
